module.exports = __webpack_public_path__ + "img/pantalla-6-3.9404831c.png";